import Kayla1 from "./kayla (1).webp";
import Kayla2 from "./kayla (2).webp";
import Kayla3 from "./kayla (3).webp";

const kayla = [Kayla1, Kayla2, Kayla3];

export default kayla;
